var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImagesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "M16.883 33.75a5.625 5.625 0 1 0 0-11.25 5.625 5.625 0 0 0 0 11.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "M52.508 48.75a7.5 7.5 0 0 1-7.5 7.5h-37.5a7.5 7.5 0 0 1-7.5-7.5v-30a7.5 7.5 0 0 1 7.492-7.5 7.5 7.5 0 0 1 7.5-7.5h37.5a7.5 7.5 0 0 1 7.5 7.5v30a7.5 7.5 0 0 1-7.492 7.5ZM52.5 7.5H15a3.75 3.75 0 0 0-3.75 3.75h33.758a7.5 7.5 0 0 1 7.5 7.5V45a3.75 3.75 0 0 0 3.742-3.75v-30A3.75 3.75 0 0 0 52.5 7.5ZM7.508 15a3.75 3.75 0 0 0-3.75 3.75v30l9.922-8.828a1.874 1.874 0 0 1 2.363-.232l9.974 6.649L39.93 32.426a1.875 1.875 0 0 1 2.164-.352l6.663 7.301V18.75a3.75 3.75 0 0 0-3.75-3.75h-37.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesIcon);
export default __webpack_public_path__ + "static/media/ImagesIcon.d24d4a9a204bc41d54f20c6fb263a345.svg";
export { ForwardRef as ReactComponent };